{
  "id": "ares",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Ares",
    "en": "Ares"
  },
  "icon": "gods/ares",
  "portrait": "gods/ares-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "cyclops": 1
  },
  "unlocks": [
    "cyclops",
    "phobos-spear-of-panic",
    "deimos-sword-of-dread",
    "enyos-bow-of-horror",
    "will-of-kronos"
  ],
  "powers": ["pestilence"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "ClassicalAgeAres: CreateUnit Cyclops at a Temple (one free myth unit), god power Pestilence (cooldown 120 s); enables the listed unit and techs."
  }
}
